import mutationsTypes from '@/vuex/arquivos-documento/mutations-types.js'
const types = {
  ...mutationsTypes,
  GET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO: 'GET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO',
  GET_LISTA_PECAS: 'GET_LISTA_PECAS',
  VALIDAR_RESTRICOES_ARQUIVO: 'VALIDAR_RESTRICOES_ARQUIVO',
  VALIDAR_TAMANHO_ARQUIVO: 'VALIDAR_TAMANHO_ARQUIVO',
  GET_ARQUIVO: 'GET_ARQUIVO',
  GET_ARQUIVO_BLOB_URL: 'GET_ARQUIVO_BLOB_URL',
  SET_ARQUIVO: 'SET_ARQUIVO',
  EXCLUIR_ARQUIVO: 'EXCLUIR_ARQUIVO',
  ENVIAR_ARQUIVO: 'ENVIAR_ARQUIVO',
  ENVIAR_ARQUIVO_ASSINADO: 'ENVIAR_ARQUIVO_ASSINADO',
  SALVAR_EDICAO_ARQUIVO: 'SALVAR_EDICAO_ARQUIVO',
  GET_LISTA_DOCUMENTOS: 'GET_LISTA_DOCUMENTOS',
  SET_LISTA_DOCUMENTOS: 'SET_LISTA_DOCUMENTOS',
  CANCELAR_PECA: 'CANCELAR_PECA',
  GET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS: 'GET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS',
  SHOW_EDICAO_ARQUIVO_DIALOG: 'SHOW_EDICAO_ARQUIVO_DIALOG',
  HIDE_EDICAO_ARQUIVO_DIALOG: 'HIDE_EDICAO_ARQUIVO_DIALOG',
  SHOW_CANCELAMENTO_PECA_DIALOG: 'SHOW_CANCELAMENTO_PECA_DIALOG',
  HIDE_EXCLUSAO_ARQUIVO_DIALOG: 'HIDE_EXCLUSAO_ARQUIVO_DIALOG',
  SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG: 'SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG',
  HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG: 'HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG',
  ATUALIZAR_SEQUENCIAL_PECA: 'ATUALIZAR_SEQUENCIAL_PECA'
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/arquivos-documento/actions-types.js